interface StatsCardProps {
  readonly label: string;
  readonly value: string;
  readonly subtitle?: string;
  readonly accent?: 'default' | 'success' | 'warning' | 'danger';
}

const ACCENT_COLORS = {
  default: 'var(--text-primary)',
  success: 'var(--color-success-600)',
  warning: '#b45309',
  danger: '#dc2626',
} as const;

export const StatsCard = ({ label, value, subtitle, accent = 'default' }: StatsCardProps) => {
  return (
    <div
      style={{
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--border-default)',
        backgroundColor: 'var(--bg-surface)',
        padding: 'var(--space-4) var(--space-5)',
      }}
    >
      <p
        style={{
          fontSize: 'var(--text-xs)',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--text-tertiary)',
          letterSpacing: '0.02em',
          marginBottom: 'var(--space-1)',
        }}
      >
        {label}
      </p>
      <p
        style={{
          fontSize: 'var(--text-2xl)',
          fontWeight: 'var(--font-weight-bold)',
          color: ACCENT_COLORS[accent],
          letterSpacing: 'var(--tracking-tight)',
          lineHeight: 1.1,
          fontFamily: 'var(--font-mono)',
        }}
      >
        {value}
      </p>
      {subtitle && (
        <p
          style={{
            fontSize: '0.7rem',
            color: 'var(--text-tertiary)',
            marginTop: 'var(--space-1)',
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};
